var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"text-center",attrs:{"cols":"6","offset":"3"}},[_c('v-alert',{staticClass:"mt-5 d-inline-block",attrs:{"dense":"","outlined":"","type":"error"}},[_vm._v("\n    記事が存在しない、もしくは編集する権限がありません。\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }